<template>
    <div class="wrapper">
        <dash-header></dash-header>
        <sidebar></sidebar>
        <div class="content-wrapper">
            <!-- Content Header (Page header) -->
            <section class="content-header">
                <div class="container-fluid">
                    <div class="row mb-2">
                        <div class="col-sm-6">
                            <h1 class="m-0 title">Bank Account</h1>
                        </div><!-- /.col -->
                        <div class="col-sm-6">
                            <ol class="breadcrumb float-sm-right">
                            <li class="breadcrumb-item"><router-link to="/dash">Home</router-link></li>
                            <li class="breadcrumb-item active">Bank Account</li>
                            </ol>
                        </div><!-- /.col -->
                    </div><!-- /.row -->
                </div><!-- /.container-fluid -->
            </section>
            <!-- /.content-header -->

            <section class="content">
                <div class="container-fluid">
                    <router-link to="/bank-account/add-card" v-if="listbank.length == 0" aria-disabled="true" role="button" class="btn btn_red mt-2 mb-4">
                        <i class="fas fa-plus mr-2"></i>
                        Add Card
                    </router-link>
                    <div class="alert alert-danger" v-if="listbank.length > 0">
                        If you want to edit or delete a bank account, please contact the admin immediately.
                    </div>
                    <div v-dragscroll class="bank_card">
                        <div class="card credit_card" v-for="bank in listbank" :key="bank.id">
                            <div class="card-header">
                                <h3 class="card-title">{{bank.owner_name}}</h3>

                                <div class="card-tools">
                                    <span class="mr-2 bank_name fw-bold">{{bank.bank_name}}</span>
                                    <!-- <button type="button" class="btn btn-tool" data-toggle="dropdown" aria-expanded="false">
                                        <i class="fas fa-ellipsis-v"></i>
                                    </button>
                                    <div class="dropdown-menu dropdown-menu-right">
                                        <router-link :to="'/bank-account/edit-card/'+bank.id" class="dropdown-item">
                                            <i class="fas fa-edit mr-2"></i>
                                            Edit
                                        </router-link>
                                        <button class="dropdown-item" v-on:click="hapusdata(bank)" type="button">
                                            <i class="fas fa-trash mr-2"></i>
                                            Hapus
                                        </button>
                                    </div> -->
                                </div>
                            </div>
                            <div class="card-body">
                                <div class="chip">
                                    <svg xmlns="http://www.w3.org/2000/svg" width="40" height="30" viewBox="0 0 40 30">
                                        <path id="chip_icon" d="M37,30H25.213v-6.41A5.688,5.688,0,0,0,27.247,22.2a6.883,6.883,0,0,0,.75-.942V21.3H40V27A3,3,0,0,1,37,30ZM24.214,30H15.787V23.229l0-.4-.391-.087a4.423,4.423,0,0,1-1.968-1.283c-1.3-1.391-1.989-3.584-1.989-6.342a9.509,9.509,0,0,1,2-6.446,4.774,4.774,0,0,1,1.976-1.376l.373-.1V0h8.427V7.195l.371.1a4.779,4.779,0,0,1,1.978,1.377,9.509,9.509,0,0,1,2,6.446c0,2.758-.688,4.951-1.989,6.342A4.421,4.421,0,0,1,24.6,22.741l-.393.088,0,.4V30Zm-9.427,0H3a3,3,0,0,1-3-3V21.3H12v-.049a6.816,6.816,0,0,0,.75.942,5.693,5.693,0,0,0,2.034,1.392V30ZM40,20.3H28.534a12.008,12.008,0,0,0,1.026-5.189,12.732,12.732,0,0,0-.841-4.811H40v10Zm-28.534,0H0v-10H11.282a12.712,12.712,0,0,0-.842,4.811A12.012,12.012,0,0,0,11.465,20.3ZM40,9.306H28.235a7.37,7.37,0,0,0-.98-1.36,6.045,6.045,0,0,0-2.041-1.482V0H37a3,3,0,0,1,3,3v6.3Zm-28.236,0H0V3A3,3,0,0,1,3,0H14.787V6.463a6.036,6.036,0,0,0-2.041,1.482A7.33,7.33,0,0,0,11.765,9.3Z" transform="translate(0 0)" fill="#fff"/>
                                    </svg>
                                </div>
                                <p class="acc_number m-0">No.Rek</p>
                                <h5 class="number fw-bold">{{bank.account_number}}</h5>

                                <div class="branch_name fw-bold">
                                    <p>{{bank.branch_name}}</p>
                                    <svg xmlns="http://www.w3.org/2000/svg" width="43" height="28.289" viewBox="0 0 43 28.289">
                                        <g id="mastercard_icon" transform="translate(-551 -339.628)">
                                            <circle id="Ellipse_1" data-name="Ellipse 1" cx="14.145" cy="14.145" r="14.145" transform="translate(551 339.628)" fill="#fff" opacity="0.52"/>
                                            <circle id="Ellipse_2" data-name="Ellipse 2" cx="14.145" cy="14.145" r="14.145" transform="translate(565.71 339.628)" fill="#fff"/>
                                        </g>
                                    </svg>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="no_bank text-center" v-if="listbank.length == 0">
                        <img src="../assets/image/payments_illustration.svg" alt="">
                        <p class="text my-3">
                            You Don't Have Bank Account Data.
                        </p>
                    </div>
                </div>
            </section>
        </div>
    </div>
</template>

<script>
import DashHeader from "../layouts/Header.vue";
// import DashFooter from "../layouts/Footer.vue";
import { dragscroll } from "vue-dragscroll";
import Sidebar from "../layouts/Sidebar.vue";
import axios from "axios";
import swal from "sweetalert";
import $ from "jquery";

export default {
    name: "Bank",
    directives: {
        dragscroll,
    },
    components: {
        DashHeader,
        // DashFooter,
        Sidebar,
    },
    data(){
        return{
            user_id: localStorage.getItem('user_id'),
            listbank: [],
        }
    },
    async mounted(){
        window.scrollTo(0,0)
        $('[data-widget="treeview"]').Treeview('init');
        
        await axios.get(`investor/bank?investor=${localStorage.user_id}`)
        .then((response)=>{
            // console.log("List Bank", response.data.data)
            this.listbank = response.data.data
        }).catch(() => {
            // console.log("Error List Bank", err.response)
        })
    },
    methods: {
        hapusdata(bank){
            swal({
                title: "Are you sure?",
                text: "Once deleted, you will not be able to recover this imaginary file!",
                icon: "warning",
                buttons: true,
                dangerMode: true,
            }).then((confirmed) => {
                if (confirmed) {
                    axios.delete(`investor/bank/${bank.id}`)
                    .then(() => {
                        // console.log(response)
                        axios.get(`investor/bank?investor=${localStorage.user_id}`).then((response)=>{
                            
                            this.listbank = response.data.data.reverse()
                        })
                        swal('Data deleted successfully', 'Please check your data again.', 'success', {
                            button: "OK"
                        })
                    }).catch((err) => {
                        console.log("Error Delete: ", err.response);
                    })
                }
            })
        }
    }
}
</script>

<style scoped>
.no_bank img{
    width: 50%;
    display: block;
    margin: 0 auto;
}
.bank_card{
    overflow-x: hidden;
    white-space: nowrap;
    /* background: blue; */
    padding: 20px 0;
    /* background: rgb(97, 96, 180); */
}

.bank_card::-webkit-scrollbar {
    /* width: 10px; */
    height: 8px;
}
/* Track */
.bank_card::-webkit-scrollbar-track {
    box-shadow: inset 0 0 4px grey; 
    border-radius: 5px;
}
/* Handle */
.bank_card::-webkit-scrollbar-thumb {
    background: #c9c9c9; 
    border-radius: 5px;
}
/* Handle on hover */
.bank_card::-webkit-scrollbar-thumb:hover {
    background: #797979; 
}


.bank_card .credit_card .card-header{
    border: none;
    background: transparent;
}
.bank_card .credit_card .card-body .chip svg path,
.bank_card .credit_card .card-body .branch_name svg circle{
    fill: #212121;
}
.bank_card .credit_card{
    width: 350px;
    margin-right: 20px;
    display: inline-block;
    border: none;
    border-radius: 10px;
    background: url('../assets/image/bank_card_bg_w.png') no-repeat, linear-gradient(-90deg, rgba(0,0,0,0) 0%, rgba(0,0,0,0.2) 100%) !important;
    color: var(--dark-grey);
    background-size: cover !important;
    background-position: center;
    box-shadow: 5px 5px 20px rgba(0,0,0,0.1);
    position: relative;
    z-index: 2 !important;
    transition: all 0.3s ease;
}
/* .bank_card .credit_card:hover{
    background: url('../assets/image/bank_card_bg.png') no-repeat, linear-gradient(90deg, rgba(22,22,22,1) 0%, rgba(65,65,65,1) 100%) !important;
    color: white;
}
.bank_card .credit_card:hover .card-body .chip svg path,
.bank_card .credit_card:hover .card-body .branch_name svg circle{
    fill: #fff;
} */
.bank_card .credit_card .card-header{
    margin: 0;
    padding-bottom: 0;
}
.bank_card .credit_card .card-header .card-tools .bank_name{
    text-transform: uppercase;
}
/* .bank_card .credit_card:hover .card-header .card-tools .btn-tool{
    color: white;
} */
.bank_card .credit_card .card-body .chip{
    margin: 0 0 10px;
}
.bank_card .credit_card .card-body .acc_number{
    font-size: 8pt;
    margin: 0;
    font-weight: 500;
}
.bank_card .credit_card .card-body .number{
    /* font-size: 10pt; */
    margin: 0;
    /* letter-spacing: 1px; */
    font-weight: 600;
}
.bank_card .credit_card .card-body .branch_name{
    display: flex;
    align-items: bottom;
    justify-content: space-between;
    margin: 10px 0 0;
}
.bank_card .credit_card .card-body .branch_name p{
    margin: 10px 0 0;
    font-weight: 500;
    text-transform: uppercase;
    font-size: 10pt;
}
/* .bank_card .credit_card::before{
    content: "";
    width: 100%;
    height: 100%;
    -webkit-backdrop-filter: blur(20px) !important;
    backdrop-filter: blur(20px) !important;
    filter: blur(10px);
    background: rgba(39, 39, 39, 0.9);
    border-radius: 10px;
    position: absolute;
    left: 0;
    bottom: 0;
    z-index: -1 !important;
} */
/* .bank_card .credit_card::after{
    content: "";
    width: 100%;
    height: 100%;
    -webkit-backdrop-filter: blur(40px) !important;
    backdrop-filter: blur(40px) !important;
    filter: blur(10px);
    background: rgba(252, 65, 65, 0.9);
    border-radius: 10px;
    position: absolute;
    left: 0;
    bottom: 0;
    z-index: -1 !important;
} */

</style>